const sortPodcasts = function (episodes) {
  return episodes.sort(
    (a, b) => new Date(b.node.postDate) - new Date(a.node.postDate)
  )
}

export default sortPodcasts
